<template>
  <div class="History">
      <div class="bg-black p-2 rounded">
        <!-- Header -->
        <div class="row">
          <div class="col-md-2">
            <div class="input-group flex-nowrap" style="height: 100%;">
              <input class="btn bg-black text-white fw-light fs-2 rounded w-100" style="width: 200px; margin-top: -4px; cursor: default; letter-spacing: 10px;" type="text" value="History" readonly>
            </div>
          </div>
          <div class="col-md-3">
            <div class="input-group flex-nowrap">
              <button class="btn btn-fluxity w-25 fs-3 me-1" style="height: 100%;"  @click="getReporters" :disabled="gettingReporters || processing">
                <i class="fa-solid fa-circle-nodes me-1" :class="{'fa-spin': gettingReporters}"></i>
                <i class="fa-solid fa-cube" :class="{'fa-beat-fade': gettingReporters}"></i>
              </button>
              <div class="w-7 me-1">
                <select class="btn btn-fluxity w-100 fs-6" style="height: 50%; border-bottom: solid 2px black;" v-model="reporter" :disabled="gettingReporters || processing" @change="clean">
                  <option :value="null">Select reporter.</option>
                  <option :value="_reporter.name" v-for="(_reporter, ri) in reporters" :key="ri">{{_reporter.name}}</option>
                </select>
                <select class="btn btn-fluxity w-100 fs-6" style="height: 50%; border-top: solid 2px black;" v-model="toptype" :disabled="gettingReporters || processing" @change="clean">
                  <option :value="null">Select type.</option>
                  <option :value="_toptype" v-for="(_toptype, ti) in toptypes" :key="ti">{{_toptype.name}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="input-group flex-nowrap" style="height: 100%;">
              <button class="btn btn-fluxity w-25 fs-3 me-1" title="Start Date." :disabled="processing">
                <i class="fa-solid fa-hourglass-start"></i>
              </button>
              <input type="date" class="btn btn-fluxity w-100 fs-5" v-model="start.date" title="Start Date" :disabled="processing">
            </div>
          </div>
          <div class="col-md-3">
            <div class="input-group flex-nowrap" style="height: 100%;">
              <button class="btn btn-fluxity w-25 fs-3 me-1" title="End Date" :disabled="processing">
                <i class="fa-solid fa-hourglass-end"></i>
              </button>
              <input type="date" class="btn btn-fluxity w-75 fs-5" v-model="end.date" title="End Date" :disabled="processing">
            </div>
          </div>
          <div class="col-md-1">
            <div class="input-group flex-nowrap" style="height: 100%;">
              <button class="btn btn-fluxity w-100 fs-3 me-1" :disabled="gettingReporters || processing || this.reporter == null || this.toptype == null || this.start.date == null || this.end.date == null" @click="getHistory(); clean(); actionMessage='Getting data, please wait.';">
                <i class="fa-solid fa-magnifying-glass"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Sections -->
      <div class="bg-black p-2 rounded mt-2" style="height: 550px;">
          <!-- Rest Area -->
          <div v-show="section=='restarea'" class="fs-3 text-white">
            <div style="margin-top: 17%;">
                <i class="fa-solid fa-xl fa-book" :class="{'fa-bounce': processing }"></i>
                <p class="text-white fw-light fa-fade">{{actionMessage}}</p>
            </div>
          </div>
          <!-- History -->
          <div class="" v-show="section=='data'" style="height: 580px;">
            <div class="row">
              <div class="col-md-1">
                <button class="btn btn-fluxity w-100 fs-5 me-1">
                  <i class="fa-solid fa-circle-info"></i>
                  {{history.length}}
                </button>
                <button class="btn btn-fluxity w-100 fs-3 mt-2 me-1" :disabled="history.length == 0" @click="getHistoryFile">
                  <i class="fa-solid fa-file-export"></i>
                </button>
                <button class="btn btn-fluxity w-100 fs-3 mt-2" @click="clean">
                  <i class="fa-solid fa-broom"></i>
                </button>
                <button class="btn w-100 fs-3 mt-2" :class="{'btn-fluxity': highlight, 'btn-dark': !highlight }" @click="highlight = !highlight">
                  <i class="fa-solid fa-lightbulb"></i>
                </button>
              </div>
              <div class="col-md-11">
                <div class="" style="height: 525px; overflow-y: scroll; overflow-x: hidden;">
                  <div class="p-1 rounded" style="height: 100%;" v-if="history.length != 0">
                    <div class="input-group flex-nowrap">
                      <button class="btn text-white fs-3 border-bottom-fluxity border-top-fluxity me-1" style="width: 45%;">
                        <i class="fa-solid fa-id-badge"></i>
                      </button>
                      <button v-if="toptype!=null" class="btn text-white fs-3 border-bottom-fluxity border-top-fluxity me-1" style="width: 23%;">
                        <i class="fa-solid fa-ethernet"></i>
                      </button>
                      <button v-if="toptype!=null && (toptype.single == 'flow' || toptype.single == 'talker')" class="btn text-white fs-6 border-bottom-fluxity border-top-fluxity me-1" style="width: 13%;">
                        Calculated Kbps
                      </button>
                      <button v-if="toptype!=null && (toptype.single == 'port')" class="btn text-white fs-6 border-bottom-fluxity border-top-fluxity me-1" style="width: 13%;">
                        Count
                      </button>
                      <button class="btn text-white fs-3 border-bottom-fluxity border-top-fluxity me-1" style="width: 22%;">
                        <i class="fa-solid fa-calendar"></i>
                      </button>
                    </div>
                    <div class="" style="height: 500px; overflow-y: scroll;" :class="{'disabled-div': gettingDetail}">
                      <div class="input-group flex-nowrap mt-1" :class="{'row-fluxity': highlight}" style="border-bottom: solid rgb(20,20,20) 1px;" v-for="(_data, di) in history" :key="di">
                        <input v-if="toptype.single == 'flow'" type="text" class="btn text-white fs-6" style="cursor: text; width: 45%;" :value="_data.id_flow" readonly>
                        <input v-if="toptype.single == 'port' || toptype.single == 'talker'" type="text" class="btn text-white fs-6" style="cursor: text; width: 45%;" :value="_data.src_or_dst" readonly>
                        <input type="text" class="btn text-white fs-6" style="cursor: default; width: 23%;" :value="_data.iface_in" readonly>
                        <input v-if="toptype.single == 'flow' || toptype.single == 'talker'" type="text" class="btn text-white fs-6" style="cursor: default; width: 13%;" :value="_data.calculated_Kbps" title="Calculated Kbps" readonly>
                        <input v-if="toptype.single == 'port'" type="text" class="btn text-white fs-6" style="cursor: default; width: 13%;" :value="_data.count" title="Count" readonly>
                        <input type="text" class="btn text-white fs-6" style="cursor: default; width: 22%;" :value="_data.timestamp" readonly>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>

      <!-- History --> 


      <!-- Top Data Element Detail -->      
      <div class="modal fade" id="td_detail" tabindex="-1">
          <div class="modal-dialog modal-dialog-centered modal-xl">
              <div class="modal-content bg-black">
                  <div class="modal-header border-0">
                      <div v-if="topdata.data!=null & tde!=null" class="input-group flex-nowrap">
                        <button class="btn btn-fluxity rounded fs-2">
                          {{topdata.data.indexOf(tde) + 1}}
                        </button>
                        <input type="text" class="btn text-white border-top-fluxity border-bottom-fluxity rounded text-start w-100 fs-4" style="cursor: text;" :value="tde.name" readonly>
                        <button class="btn rounded fs-2 me-2" :class="{'btn-fluxity': highlight, 'btn-dark': !highlight }" @click="highlight = !highlight">
                          <i class="fa-solid fa-lightbulb"></i>
                        </button>
                        <button class="btn btn-fluxity rounded fs-2 me-2" @click="getDetailFile">
                          <i class="fa-solid fa-file-export"></i>
                        </button>
                        <button class="btn btn-danger fs-2 rounded" data-bs-dismiss="modal">
                          <i class="fa-solid fa-close"></i>
                        </button>
                      </div>
                  </div>
                  <div class="modal-body">
                      <div v-if="tde!=null" class="input-group flex-nowrap">
                        <button class="btn text-white fs-3 border-bottom-fluxity border-top-fluxity me-1" style="width: 50%;">
                          <i class="fa-solid fa-id-badge"></i>
                        </button>
                        <button v-if="toptype!=null" class="btn text-white fs-3 border-bottom-fluxity border-top-fluxity me-1" style="width: 20%;">
                          Value (Mbps)
                        </button>
                        <button class="btn text-white fs-3 border-bottom-fluxity border-top-fluxity me-1" style="width: 30%;">
                          <i class="fa-solid fa-calendar"></i>
                        </button>
                      </div>
                      <div class="input-group flex-nowrap" :class="{'row-fluxity': highlight}" v-for="(_det, dti) in tde_detail" :key="dti">
                        <input type="text" class="btn text-white fs-6" style="cursor: text; width: 50%;" :value="_det.name" readonly>
                        <input type="text" class="btn text-white fs-6" style="cursor: text; width: 20%;" :value="`${_det.value}`" readonly>
                        <input type="text" class="btn text-white fs-6" style="cursor: text; width: 30%;" :value="_det.timestamp" readonly>
                      </div>
                  </div>
              </div>
          </div>
      </div>

      <!-- Form to Generate the backup txt File -->
      <form :action="file_action" method="GET" id="hf_form" target="formware" style="display: none">
          <input type="text" name="unique" v-model="unique" readonly>
          <input type="text" name="reporter" v-model="reporter" readonly>
          <input v-if="toptype != null" type="text" name="type" v-model="toptype.single" readonly>
          <input type="text" name="start" v-model="start.date" readonly>
          <input type="text" name="end" v-model="end.date" readonly>

      </form>

      <!-- Target of all the download forms-->
      <iframe name="formware" id="formware" frameborder="0" style="display: none;"></iframe>


  </div>
</template>

<script>
// Import the component with the line below.
//import Base from '@/components/Base.vue'
import TDChart from '@/components/apps-components/fluxity/subs/charts/TDChart.vue'

import axios from "axios";

export default {
  name: 'History',
  components: {
    TDChart
  },
  data(){
    return {
      // General
      site: null,
      stage: null,
      section: 'restarea',
      mode: 0, // 0  = Graph ,  1 = List
      processing: false,
      unique: null,
      start: null,
      // Reporters
      gettingReporters: false,
      reporters: [],
      reporter: null,
      // Toptypes
      toptypes: [
        {
          name: 'Talkers',
          single: 'talker',
          value: 'getTopTalkers'
        },
        {
          name: 'Flows',
          single: 'flow',
          value: 'getTopFlows'
        },
        {
          name: 'Ports',
          single: 'port',
          value: 'getTopPorts'
        },

      ],
      toptype: null,
      // History
      history: [],




      // Top Data
      topdata: {
        data: null,
        graph_data: null
      },
      tde: null,
      tde_detail: [],
      gettingDetail: false,

      // Datetime
      start: {date: null, time: '00:00'},
      end: {date: null, time: null},

      highlight: false,
      action: "default",
      actionMessage: "Set parameters and get history."
    }
  },
  methods:{
    
    // Reporters
    getReporters(){
      this.gettingReporters = true
      this.reporter = null
      const params = {}
      const dest = this.site + '/fluxity/history/getReporters'
      axios
          .get(dest, {params})
          .then(rx => {
              this.reporters = rx.data
              this.gettingReporters = false
          })
          .catch(error => {
              this.processErrorMessage(error)
              this.gettingReporters = false
          });
    },
    // History
    getHistory(){
      this.processing = true
      this.actionMessage = "Processing request..."
      const params = {reporter: this.reporter, type: this.toptype.single, start: this.start.date, end: this.end.date}
      const dest = this.site + '/fluxity/history/getHistory'
      axios
          .get(dest, {params})
          .then(rx => {
              this.history = rx.data.data
              this.processing = false
              this.section = 'data'
          })
          .catch(error => {
            console.log(error)
              this.processErrorMessage(error)
              this.processing = false
          });
    },
    getHistoryFile(){
      this.setUnique()
      if ( !confirm('Download history in excel?') ){
          return
      }
      hf_form.submit()
    },





    // Top Data
    

    getTDDetail(_element){
      this.tde = _element
      // Sending
      this.gettingDetail = true
      const params = {reporter: this.reporter, type: this.toptype.single, name: _element.name}
      console.log(params)
      const dest = this.site + '/fluxity/visualizer/getTopDataDetail'
      axios
          .get(dest, {params})
          .then(rx => {
              this.gettingDetail = false
              this.tde_detail = rx.data.data
              console.log(this.tde_detail)
              document.getElementById('ombtn').click()
          })
          .catch(error => {
            console.log(error)
              this.processErrorMessage(error)
              this.gettingDetail = false
          });
    },

    setUnique(){
        var date = new Date();
        this.unique = date.getTime()
    },
    clean(){
      this.history = []
      this.section = 'restarea'
      this.actionMessage = "Set parameters and get history."
    },

    setNow(){
        this.now = new Date();

        // Day
        if (this.now.getDate() < 10){
            var day = '0' + String(this.now.getDate())
        }
        else{
            var day = this.now.getDate()
        }
        // Month
        if (this.now.getMonth()+1 < 10){
            var month = '0' + String(this.now.getMonth()+1)
        }
        else{
            var month = this.now.getMonth()+1
        }


        this.today = `${this.now.getFullYear()}-${month}-${day}`

        if (this.now.getHours() < 10){
            var h = '0' + String(this.now.getHours())
        }
        else{
            var h = this.now.getHours()
        }

        if (this.now.getMinutes() < 10){
            var m = '0' + String(this.now.getMinutes())
        }
        else{
            var m = this.now.getMinutes()
        }
        this.time = `${h}:${m}`
        this.start.date = this.today
        this.end.date = this.today
        this.end.time = this.time
    },


    // Errors
    processErrorMessage(error, mode="alert"){
        var err_message = null
        try {
            err_message = error.response.data.error
        } 
        catch (nerror) {
            try { 
                err_message = error.response.data.error
            } 
            catch (error) { 
                console.log(error) 
            }
        }
        if (mode == "alert"){ alert(err_message)  }
        else if (mode == "console"){ console.log(err_message)  }
    return err_message
    },

    // -- Miscellaneous
    capitalize(_string){
        if (_string == null){return ""}
        const lower = String(_string).toLowerCase()
        return String(_string).charAt(0).toUpperCase() + lower.slice(1)
    },
    cloneObject(_object){
      return JSON.parse(JSON.stringify(_object))
    },
    getCookie(name){
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
            cookie = cookie.trim();
            if (cookie.startsWith(name + '=')) {
              return cookie.substring(name.length + 1);
            }
      }
      return null;
    }
  },
  created: function(){
    //this.getUsers()
    //this.setNow()
    //this.getReporters()
    this.stage = process.env.NODE_ENV
    if (this.stage == 'development'){
      this.site = process.env.VUE_APP_SERVICE_URL
    }
    else{
      this.site = `${window.location.protocol}//${window.location.host}/kraken`
    }
    // Setting
    axios.defaults.headers.common['X-CSRFToken'] = this.getCookie('csrf_prt')
    this.file_action= `${this.site}/fluxity/history/getHistoryFile`
  },
  mounted: function(){
    this.setUnique()
    this.setNow()
    this.getReporters()
  }
}
</script>

<style scoped>
  
  .btn-fluxity{
    background-color: rgb(255, 89, 0);
    transition-duration: 0.7s;
    color: white;
  }
  .btn-fluxity:hover{
    background-color: rgb(186, 65, 0);
  }
  .border-fluxity{
    border: solid 4px rgb(255, 89, 0);
  }
  .border-bottom-fluxity{
    border-bottom: solid 2px rgb(255, 89, 0);
  }
  .border-top-fluxity{
    border-top: solid 2px rgb(255, 89, 0);
  }
  .row-fluxity{
    transition-duration: 0.7s;
    opacity: 0.3;
  }
  .row-fluxity:hover{
    opacity: 1.0;
  }

  .disabled-div{
      pointer-events: none;
      opacity: 0.5;
  }




  /* Scrollbar */
  /* width */
  ::-webkit-scrollbar {
      width: 10px;
      height: 7px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgb(37, 33, 33); 
      border-radius: 10px;
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: rgb(64, 133, 88); 
      border-radius: 10px;
      transition-duration: 2.0s;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: rgb(54, 112, 75); 
  }

</style>
